import React from 'react';
import { motion } from 'framer-motion';
import { IconWhatsApp } from './ui/Icons';
export function FloatingWhatsApp() {
  return <motion.a href="https://wa.me/59899000000" // Placeholder Uruguayan number
  target="_blank" rel="noopener noreferrer" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1.5,
    type: 'spring',
    stiffness: 260,
    damping: 20
  }} className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300" aria-label="Contactar por WhatsApp" data-id="element-103">
      <IconWhatsApp className="w-7 h-7" data-id="element-104" />

      {/* Pulse effect */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" style={{
      animationDuration: '3s'
    }} data-id="element-105" />
    </motion.a>;
}